import * as React from "react";
import styleable from "react-styleable";

import * as inputStyle from '../../../css/components/mainlayout/PortalInput.css';

/**
 * ## styleable
 * * **label** Styling for the label.
 * * **input** Styling for the input box.
 *
 */
class PortalInputLarge extends React.Component<any, any> {

    constructor(){
        super(undefined); // TODO: undefined
        this.state = {
            value: "",
        }
    }

    componentWillMount(){
        if(this.props.value !== undefined){
            this.setState({
                value: this.props.value
            });
        }
    }

    render() {
        return (
            <span>
                <i className={this.props.css.label}>{this.props.placeholder}</i>
                <textarea className={this.props.css.input} placeholder={this.props.placeholder} value={this.props.value} onChange={(e) => {
                    if(this.props.onChange !== undefined){
                        this.props.onChange(e.target.value);
                    }
                    this.setState({value: e.target.value});
                }}/>
            </span>
        );
    }
}
export default styleable(inputStyle)(PortalInputLarge);